/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MemberCodeOutput
 */
export interface MemberCodeOutput {
    /**
     * generated code with 12 digits
     * @type {string}
     * @memberof MemberCodeOutput
     */
    code?: string;
    /**
     * the status of the MZ Access
     * @type {MemberCodeOutputStatusEnum}
     * @memberof MemberCodeOutput
     */
    status?: MemberCodeOutputStatusEnum;
    /**
     * creation date of the member code
     * @type {Date}
     * @memberof MemberCodeOutput
     */
    activationDate?: Date;
    /**
     * creation date of the member code
     * @type {Date}
     * @memberof MemberCodeOutput
     */
    generationDate?: Date;
    /**
     * expire date of the member code
     * @type {Date}
     * @memberof MemberCodeOutput
     */
    expirationDate?: Date;
    /**
     * expire date of the member code
     * @type {Date}
     * @memberof MemberCodeOutput
     */
    revocationDate?: Date;
    /**
     * RelationshipManager name
     * @type {string}
     * @memberof MemberCodeOutput
     */
    rmName?: string;
}


/**
 * @export
 */
export const MemberCodeOutputStatusEnum = {
    Sent: 'SENT',
    Activated: 'ACTIVATED',
    Expired: 'EXPIRED',
    Revoked: 'REVOKED'
} as const;
export type MemberCodeOutputStatusEnum = typeof MemberCodeOutputStatusEnum[keyof typeof MemberCodeOutputStatusEnum];


/**
 * Check if a given object implements the MemberCodeOutput interface.
 */
export function instanceOfMemberCodeOutput(value: object): value is MemberCodeOutput {
    return true;
}

export function MemberCodeOutputFromJSON(json: any): MemberCodeOutput {
    return MemberCodeOutputFromJSONTyped(json, false);
}

export function MemberCodeOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberCodeOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'status': json['status'] == null ? undefined : json['status'],
        'activationDate': json['activationDate'] == null ? undefined : (new Date(json['activationDate'])),
        'generationDate': json['generationDate'] == null ? undefined : (new Date(json['generationDate'])),
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
        'revocationDate': json['revocationDate'] == null ? undefined : (new Date(json['revocationDate'])),
        'rmName': json['rmName'] == null ? undefined : json['rmName'],
    };
}

export function MemberCodeOutputToJSON(json: any): MemberCodeOutput {
    return MemberCodeOutputToJSONTyped(json, false);
}

export function MemberCodeOutputToJSONTyped(value?: MemberCodeOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'status': value['status'],
        'activationDate': value['activationDate'] == null ? value['activationDate'] : value['activationDate'].toISOString(),
        'generationDate': value['generationDate'] == null ? value['generationDate'] : value['generationDate'].toISOString(),
        'expirationDate': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString(),
        'revocationDate': value['revocationDate'] == null ? value['revocationDate'] : value['revocationDate'].toISOString(),
        'rmName': value['rmName'],
    };
}

